var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlaveDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18629",
    "data-name": "Rectangle 18629",
    width: 83.363,
    height: 100,
    fill: "#0050ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23602",
    "data-name": "Group 23602",
    transform: "translate(-570 -2078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23599",
    "data-name": "Group 23599",
    transform: "translate(256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-773 417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23601",
    "data-name": "Group 23601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23596",
    "data-name": "Group 23596",
    transform: "translate(1150 1716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23594",
    "data-name": "Group 23594",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50007",
    "data-name": "Path 50007",
    d: "M75.5,0a2.276,2.276,0,0,1,1.257,2.033c.468,5.674.981,11.345,1.477,17.016q.843,9.626,1.682,19.252.824,9.481,1.641,18.962.833,9.578,1.67,19.155c.073.842.129,1.689.13,2.534q.016,9.277.005,18.554c0,2.021-.465,2.494-2.445,2.494H2.5C.551,100,.055,99.52.058,97.6.067,91-.131,84.38.157,77.784c.284-6.495,1.064-12.968,1.626-19.45Q2.6,48.9,3.422,39.47q.846-9.724,1.693-19.447c.522-6,1.056-11.991,1.549-17.99A2.275,2.275,0,0,1,7.92,0ZM73.523,3.4H9.895Q6.57,41.718,3.253,79.946H80.178C77.957,54.4,75.744,28.938,73.523,3.4m6.453,80.018H3.458V96.592H79.977Z",
    transform: "translate(0)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50009",
    "data-name": "Path 50009",
    d: "M75.406,335.634v-3.206h3.256v6.545H38.808v-6.539h3.237v3.2Z",
    transform: "translate(-28.682 -245.689)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18622",
    "data-name": "Rectangle 18622",
    width: 6.516,
    height: 3.24,
    transform: "translate(60.115 88.371)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18623",
    "data-name": "Rectangle 18623",
    width: 6.569,
    height: 3.184,
    transform: "translate(68.426 88.394)",
    fill: "#0050ad"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-link",
    "data-name": "Icon metro-link",
    d: "M15.833,21.081a1.561,1.561,0,0,1-1.108-.459,7.359,7.359,0,0,1,0-10.4l5.784-5.784a7.351,7.351,0,1,1,10.4,10.4l-2.644,2.644a1.567,1.567,0,0,1-2.215-2.215l2.644-2.644a4.218,4.218,0,0,0-5.965-5.964l-5.784,5.784a4.222,4.222,0,0,0,0,5.965,1.567,1.567,0,0,1-1.108,2.674Zm-5.55,11.334a7.351,7.351,0,0,1-5.2-12.548l2.644-2.644a1.567,1.567,0,0,1,2.215,2.215L7.3,22.082a4.218,4.218,0,0,0,5.965,5.964l5.784-5.784a4.223,4.223,0,0,0,0-5.965,1.567,1.567,0,1,1,2.215-2.215,7.359,7.359,0,0,1,0,10.4l-5.784,5.784a7.3,7.3,0,0,1-5.2,2.153Z",
    transform: "translate(1174.064 1732.71)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18630",
    "data-name": "Rectangle 18630",
    width: 3.207,
    height: 3.241,
    transform: "translate(1190.096 1775.045)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18631",
    "data-name": "Rectangle 18631",
    width: 3.229,
    height: 3.205,
    transform: "translate(1176.738 1775.069)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18632",
    "data-name": "Rectangle 18632",
    width: 3.199,
    height: 3.234,
    transform: "translate(1183.422 1775.047)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18633",
    "data-name": "Rectangle 18633",
    width: 3.236,
    height: 3.18,
    transform: "translate(1196.777 1775.081)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18634",
    "data-name": "Rectangle 18634",
    width: 3.221,
    height: 3.199,
    transform: "translate(1203.456 1775.053)",
    fill: "#0050ad"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49986",
    "data-name": "Path 49986",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6703.177 2365)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlaveDevice);
export default __webpack_public_path__ + "static/media/slave-device.e2eba981e9f08336368d75443f6ad224.svg";
export { ForwardRef as ReactComponent };